import { gql, useQuery } from '@apollo/client';
import {
  UseUserNotifcationSettingsDataGetTeamsUserNotificationSettings,
  UseUserNotifcationSettingsDataQuery,
  UseUserNotifcationSettingsDataQueryVariables,
} from './__generated__/useUserNotificationSettingsData.generated';

export type UserNotificationSetting =
  UseUserNotifcationSettingsDataGetTeamsUserNotificationSettings;

export const GET_USER_NOTIFICATION_SETTINGS = gql`
  query UseUserNotifcationSettingsData($userId: ID!) {
    getTeamsUserNotificationSettings(userId: $userId) {
      name
      ownerId
      values
    }
  }
`;

export const useUserNotificationSettingsData = (userId: string) => {
  const { data, loading } = useQuery<
    UseUserNotifcationSettingsDataQuery,
    UseUserNotifcationSettingsDataQueryVariables
  >(GET_USER_NOTIFICATION_SETTINGS, {
    variables: {
      userId: userId,
    },
    fetchPolicy: 'cache-and-network',
  });

  return {
    loading,
    data: data?.getTeamsUserNotificationSettings ?? [],
  };
};
